import React from "react";
import cx from "classnames";
import { Image } from "src/components/image";
import { Reveal } from "src/components/reveal";

import * as styles from "./certifications.module.css";

export interface SustainabilityCertificationsProps {
	certifications: [
		{
			_key: string;
			png: {
				alt?: string;
				asset: any;
			};
			url?: string;
		}
	];
}

export const SustainabilityCertifications = ({
	data,
}: {
	data: SustainabilityCertificationsProps;
}) => {
	const { certifications } = data;

	return (
		<div className={cx("hide-scrollbar", styles.certifications)}>
			{certifications &&
				certifications.map((item, index) => (
					<Reveal key={item._key} delay={index * 100}>
						<div
							className={styles.item}
							style={
								{
									"--ar": item.png.asset.metadata.dimensions.aspectRatio,
								} as React.CSSProperties
							}
						>
							<a href={item.url} target="_blank" rel="noopener noreferrer">
								<Image
									className={styles.png}
									imageId={item.png.asset._id}
									alt={item.png.alt || ""}
									gatsbyImageClassName={styles.gatsbyImage}
									objectFit="contain"
								/>
							</a>
						</div>
					</Reveal>
				))}
		</div>
	);
};
